import { createModal } from '/@/core/elements/modal'

interface SlideshowModalData {
  title: string
  images: string[]
  imageIndex: number
}

const { api, component } = createModal<SlideshowModalData>(
  'SlideshowModal',
  () => import('./SlideshowModal.vue'),
  {
    title: '',
    images: [],
    imageIndex: 0,
  },
)

export const useSlideshowModal = api
export default component
